import { render, staticRenderFns } from "./EditBusinessDetailsModal.vue?vue&type=template&id=4c819af8"
import script from "./EditBusinessDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditBusinessDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports